var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchyAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5C7.5 12.0523 8.00368 12.5 8.625 12.5H9.03953L4.57292 18.0833C4.39142 18.0291 4.19911 18 4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20C6 19.6441 5.90705 19.31 5.74411 19.0205L10.9605 12.5H11.25V18.1454C10.517 18.4421 10 19.1607 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 19.1607 13.483 18.4421 12.75 18.1454V12.5H13.0395L18.2559 19.0205C18.0929 19.31 18 19.6441 18 20C18 21.1046 18.8954 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C19.8009 18 19.6086 18.0291 19.4271 18.0833L14.9605 12.5H15.375C15.9963 12.5 16.5 12.0523 16.5 11.5C16.5 9.29086 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.29086 7.5 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchyAlt1);
export default __webpack_public_path__ + "static/media/hierarchy-alt-1.c137e998f1151fa1e8bbf9934bb74896.svg";
export { ForwardRef as ReactComponent };